const uberV2 = {
  voucherDueDateTitle: 'Due date',
};

module.exports = uberV2;
